// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWrapper_container__2Spie"};